import _ from 'lodash';
import { FEATURE_FLAGS } from '../api/config';
export var useFeatureFlag = function useFeatureFlag(flagName, defaultValue) {
  if (_.isObject(FEATURE_FLAGS) && !_.isEmpty(FEATURE_FLAGS)) {
    return _.get(FEATURE_FLAGS, flagName, defaultValue);
  }
  return defaultValue;
};
//# sourceMappingURL=useFeatureFlag.js.map